import React, { useEffect, useState } from "react";
import {
  Box,
  useTheme,
  useMediaQuery,
  CircularProgress,
  Typography,
} from "./MuiImports";
import GnomeBg from "../../assets/images/gnome_bg.jpg";
import DoleBg from "../../assets/images/dole_bg.jpg";
import FigBg from "../../assets/images/action_fig_bg.jpg";

const ERROR_TEXT = {
  DEFAULT_HEADER: "Error 404",
  ERROR_DETAILS: "That page doesn't exist, but this place does.",
};

const backgroundImages = [
  {
    url: GnomeBg,
    name: "dsm",
    location: "Des Moines International Airport",
    caption:
      " in Iowa is one of a million Boingo hotspots worldwide. While you're in town, go to Reiman Gardens and visit the world's largest concrete gnome.",
    creds: "Virtual Farm Boy on Flickr",
    href: "https://www.flickr.com/photos/virtualfarmboy/6296690763",
  },
  {
    url: FigBg,
    name: "okc",
    location: "Will Rogers Airport",
    caption:
      " in Oklahoma is one of a million Boingo hotspots worldwide. While you're in town, go check out the super Toy and Action Figure Museum.",
    creds: "Jimmy Bramlett on Flickr",
    href: "https://www.flickr.com/photos/artindeepkoma/8513548155",
  },
  {
    url: DoleBg,
    name: "hnl",
    location: "Daniel K. Inouye International Airport",
    caption:
      " in Hawaii is one of a million Boingo hotspots worldwide. While you're in town, try the world's largest plant maze at Dole pineapple plantation.",
    creds: "Smart Destinations on Flickr",
    href: "https://www.flickr.com/photos/gocardusa/3753439312",
  },
];

type BgImage = {
  url: string;
  location?: string;
  name?: string;
  caption: string;
  creds: string;
  href: string;
};

const GenericError: React.FC = ({ error }: { error?: any }) => {
  const [bgImg, setBgImg] = useState<BgImage>(backgroundImages[0]);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    setBgImg(randomImage());
  }, []);

  const randomImage = () => {
    return backgroundImages[
      Math.floor(Math.random() * backgroundImages.length)
    ];
  };

  return (
    <Box
      sx={{
        height: "100vh",
        background: `radial-gradient(transparent 15%, black 190%), url(${bgImg.url}) center no-repeat`,
        backgroundSize: "cover",
      }}
    >
      <Box
        sx={{
          justifyContent: "center",
          margin: "0 auto",
          alignItems: "center",
          display: "flex",
          flexDirection: "column",
          padding: "0 10px",
        }}
      >
        <Typography
          fontFamily="Museo900"
          sx={{
            mt: 6,
            color: "#35C0e2",
            fontSize: "24px",
          }}
        >
          {ERROR_TEXT.DEFAULT_HEADER}
        </Typography>
        <Typography
          fontFamily="Museo900"
          sx={{
            textAlign: "center",
            color: "white",
            fontSize: isMobile ? "22px" : "32px",
          }}
        >
          {ERROR_TEXT.ERROR_DETAILS}
        </Typography>

        <Typography
          id="img-caption"
          sx={{
            display: "inline-span",
            fontFamily: isMobile ? "Figtree-Semibold" : "Figtree-Regular",
            color: "white",
            fontSize: isMobile ? "14px" : "20px",
            mt: isMobile ? 3 : 50,
            mb: 8,
            textAlign: "center",
            width: isMobile ? "80%" : "60%",
          }}
        >
          <Typography
            id="img-location"
            component="span"
            sx={{
              color: "white",
              fontSize: isMobile ? "16px" : "20px",
              fontFamily: "Museo900",
            }}
          >
            {bgImg.location ?? ""}
          </Typography>
          {bgImg.caption}
        </Typography>
        <Typography
          component="a"
          href={bgImg.href}
          id="img-creds"
          sx={{
            fontFamily: "Figtree-Semibold",
            textDecoration: "none",
            color: "white",
            fontSize: "12px",
          }}
        >
          Photo:{" "}
          <span style={{ textDecoration: "underline" }}>{bgImg.creds}</span>{" "}
          (Creative Commons)
        </Typography>
      </Box>
    </Box>
  );
};

export default GenericError;
